import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PrimeNGModule } from '../../modules/primeng.module';

@Component({
    selector: 'app-action-bar',
    templateUrl: './action-bar.component.html',
    styleUrl: './action-bar.component.scss',
    imports: [PrimeNGModule],
    standalone: true
})
export class ActionBarComponent {

  constructor() { }
  @Input() label: string = 'CONTINUE';
  @Input() backLabel: string = 'Back';
  @Output() backClicked: EventEmitter<Event> = new EventEmitter();
  @Output() saveClicked: EventEmitter<Event> = new EventEmitter();
  @Input() disabled: boolean = false;


  onSave() { 
    this.saveClicked.emit();
  }

  navigateBack() {
    this.backClicked.emit();
  }
}
